export const inceptionModels = {
    id: "inception",
    name: "Inception",
    api: "https://api.inceptionlabs.ai/v1/",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://platform.inceptionlabs.ai/docs",
    env: ["INCEPTION_API_KEY"],
    models: {
        "mercury-coder": {
            id: "mercury-coder",
            name: "Mercury Coder",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2025-02-26",
            last_updated: "2025-07-31",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.25,
                output: 1,
                cache_read: 0.25,
                cache_write: 1,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        mercury: {
            id: "mercury",
            name: "Mercury",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2025-06-26",
            last_updated: "2025-07-31",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.25,
                output: 1,
                cache_read: 0.25,
                cache_write: 1,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
    },
};
export default inceptionModels;
//# sourceMappingURL=inception.js.map